import { biVizIcon } from '@euler/app/components/message/widgets/bi-visualization/functions/biVizIcon';
import { kBiVizTypeLabels } from '@euler/app/components/message/widgets/bi-visualization/functions/biVizLabels';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiVizType } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../components/ui/BiChip';
import { EditorSection } from './EditorSection';
import {
  BiEditorState,
  biEditorWithTotalsParts,
} from './functions/biEditorState';
import { biEditorTypeOffered } from './functions/biEditorTypeOffered';

const kTypes = Object.values(BiVizType);

/**
 * The chart type, and for a KPI whether it compares with the last period.
 * A radar or a pyramid is offered only when the preview's shape fits it.
 */
export const VizSection = memo(
  ({
    state,
    result,
    onChange,
  }: {
    state: BiEditorState;
    /** The live preview's rows; null while there are none. */
    result: BiQueryResult | null;
    onChange: (next: BiEditorState) => void;
  }) => (
    <EditorSection title="图表类型" wrap>
      {kTypes
        .filter(type => biEditorTypeOffered(state, type, result))
        .map(type => (
          <BiChip
            key={type}
            icon={biVizIcon(type)}
            label={kBiVizTypeLabels[type]}
            selected={state.vizType === type}
            onPress={() =>
              onChange(
                // Several datasets' totals read only as a KPI group.
                type !== BiVizType.KpiGroup && state.totalsParts.length
                  ? { ...biEditorWithTotalsParts(state, []), vizType: type }
                  : { ...state, vizType: type },
              )
            }
          />
        ))}
      {state.vizType === BiVizType.Kpi ||
      state.vizType === BiVizType.KpiGroup ? (
        <BiChip
          label="对比上期"
          selected={state.kpiCompare}
          // Never stuck on: it can always be turned off.
          disabled={
            !state.kpiCompare &&
            [state, ...state.totalsParts].some(part => !part.timeRange)
          }
          onPress={() => onChange({ ...state, kpiCompare: !state.kpiCompare })}
        />
      ) : null}
    </EditorSection>
  ),
);
